export default {
  'oss.oss-config.scheme': 'URL Protocol',
};
